import Image from 'next/image';
import styled from '@emotion/styled';

export const Container = styled.section``;
export const Inner = styled.div`
  padding: 80px 0 40px;
  display: flex;
  justify-content: center;
`;
export const BenefitList = styled.ul`
  display: flex;
  gap: 16px;
`;
export const Benefit = styled.li`
  padding: 10px 16px;
  display: flex;
  justify-content: center;
  color: #121212;
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  border-radius: 999px;
  border: 2px solid transparent;
  background:
    linear-gradient(white, white) padding-box,
    linear-gradient(to right, #3648f3, #e6764a) border-box;
`;
export const Icon = styled(Image)`
  margin-right: 6px;
`;
